import Link from "next/link";
import styles from "./styles.module.scss";

interface ComponentTypes {
  items: Array<number>;
  link: string;
  pageActive: number;
}

export const PaginationPosts = ({
  items,
  link,
  pageActive,
}: ComponentTypes) => {
  return (
    <div className={styles.paginator}>
      {items.length > 0 &&
        items.map((item, index) => {
          let isNum = true;
          if (typeof item != "number") isNum = false;
          return (
            <div key={index}>
              {isNum ? (
                <Link
                  href={`${link}/${item}`}
                  passHref
                  className={styles.btnPagination}
                  data-active={pageActive == item && true}
                >
                  {item}
                </Link>
              ) : (
                <span key={index}>{item}</span>
              )}
            </div>
          );
        })}
    </div>
  );
};
